/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Four_KkInputs */

const cs_enum_four_kk = /** @type {(inputs: Enum_Four_KkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4+kk`)
};

const en_enum_four_kk = /** @type {(inputs: Enum_Four_KkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4+kk`)
};

/**
* | output |
* | --- |
* | "4+kk" |
*
* @param {Enum_Four_KkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_four_kk = /** @type {((inputs?: Enum_Four_KkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Four_KkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_four_kk(inputs)
	return cs_enum_four_kk(inputs)
});